import { Component, OnInit, Inject, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { GrowerOrderService } from './../../../services/seed/growerOrder.service';
import { DealerService } from './../../../services/seed/dealer.service';

import { GrowerOrderItemVM, errorCodes } from '../../../models/GrowerOrderItemVM';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import * as $ from 'jquery';
import { MasterConstants } from '../../constants/master-constants';
import { CommonService } from '../../../services/common/common.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-product-change',
  templateUrl: './product-change.component.html',
  styleUrls: ['./product-change.component.scss']
})

export class ProductChangeComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  fromProduct: GrowerOrderItemVM = null;
  fromProductList: GrowerOrderItemVM[] = [];
  changeListDS: GrowerOrderItemVM[];
  returnItemList: GrowerOrderItemVM[] = [];
  totalItems: number;
  counter = 0;
  hasChangeAdded = false;

  // component variables at component initialize
  itemId: number;
  accountNo: number;
  action: string;
  btnAction: string;
  companyCode: string;
  cropYear: number;
  sendData = false;
  btnTxt: string;
  totalSum = 0;
  noError = true;
  page: string;
  globalKey = { 'Key': 'Modify', 'Values': [] };
  isShowPreviousBtn = false;
  isShowNextBtn = false;
  showCutOverWarning: boolean;
  cutOverPackageSizeMessage: string;
  hasEligibleEAUnits: boolean = false;
  isAllChecked: boolean = false;
  isEAModifiableUnitsShow = false;

  isAccountRIB: boolean;
  constructor(
    public sliderModelService: SliderModelService,
    public growerOrderService: GrowerOrderService,
    public matDialog: MatDialog,
    public loaderService: LoaderService,
    public dealerService: DealerService,
    public configService: ConfigService,
    public broadcastService: BroadcastService,
    public commonService: CommonService,
    @Inject('BASE_URL') public baseUrl: any) {
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    this.cutOverPackageSizeMessage = MasterConstants.CUTCANCEL_PACKAGE_SIZE_MESSAGE;
  }

  ngOnInit() {
    this.subscription.push(this.sliderModelService.initializeProductChangeValue.subscribe(x => {
      // localStorage.clear();
      this.action = x.action;
      this.accountNo = x.accountNo;
      this.companyCode = x.companyCode;
      this.cropYear = x.cropYear;
      this.page = x.page;
      this.btnAction = (this.action == 'PackageSize') ? 'PACKAGE SIZE' : (this.action == 'SeedSize' ? 'SEED SIZE' : 'TREATMENT');
      if (this.btnAction == 'PACKAGE SIZE' || this.btnAction == 'TREATMENT') {
        this.isEAModifiableUnitsShow = true;
      }
        this.isAccountRIB = x.isAccountRIB;
      // Set component values
      // TODO: Sumit - GMK
      if (this.page == 'dealerSlider') {
        const dataList = x.dealerData;
        dataList.forEach(x => {
          this.fromProductList.push({
            isSelected: true,
            growerOrderID: 0,
            growerOrderItemId: 0,
            growerGLN: '',
            growerGMK: 0,
            shipToAccount: x.shipToAccount,
            desiredDeliveryDate: new Date(),
            createTimeStamp: x.createdTimestamp,
            updateTimeStamp: x.updatedTimestamp,
            itemID: x.itemID,
            brand: x.brand,
            itemNumber: x.itemNumber,
            dealerOrderItemId: x.dealerOrderItemId,
            dealerOrderNumber: x.dealerOrderNumber,
            growerOrderNumber: '',
            lineNumber: x.lineNumber,
            itemDescription: x.itemDescription,
            seedSize: x.seedSize,
            treatment: x.treatment,
            maturity: x.maturity,
            technology: x.technology,
            productLine: x.productLine,
            marketingBrand: x.marketingBrand,
            packageSize: x.packageSize,
            customerPO: '',
            status: 'Y',
            conv: x.conv,
            seedAvailability: x.seedAvailability,
            geu: x.modifiableUnit,
            netGEU: x.netGEU,
            netBEU: x.netBEU,
            sellerID: 0,
            myDealerBucketQty: x.myDealerBucketQty,
            longShortPosition: x.longShortPosition,
            highlightPackage: x.highlightPackage,
            highlightTreatment: x.highlightTreatment,
            highlightTechnology: x.highlightTechnology,
            errorFlag: false,
            softCommitUnits: x.softCommitUnits,
            plannedUnits: x.plannedUnits,
            shippedUnits: x.shippedUnits,
            errors: [],
            primaryUOM: x.primaryUOM,
            secondaryUOM: x.secondaryUOM,
            ChangeType: x.ChangeType,
            cutCancelOverDate: x.cutCancelOverDate,
            cutOverDate: x.cutOverDate,
            cutOverWarning: x.cutOverWarning,
            showCutOverWarning: false,
            stockTransferUnits: x.stockTransferUnits,
            seedNonReturnable: x.seedNonReturnable,
            eaShippedUnits: x.eaShippedUnits,
            eaPlannedUnits: x.eaPlannedUnits,
            eaUnits: x.eaUnits,
            myDealerBucket: x.myDealerBucket,
            dealerModifiableUnits: x.dealerModifiableUnits,
            eaModifiableUnits: x.eaModifiableUnits,
            isItemInInclusion: x.isItemInInclusion,
            isEAModifiableChecked: false,
            itemGroup: x.itemID.toString(),
            isRIB: x.isRIB

          });
        });
      }
      else {
        this.fromProductList = x.data;

        // to add change type for grower order
        this.fromProductList.forEach(x => {
          x.ChangeType = x.ChangeType;
        });
      }

      this.totalItems = this.fromProductList.length;
      this.fromProduct = null;
      this.MoveToNextItem();
      this.sliderModelService.initializeProductChangeValue.observers = [];
    }));

    this.subscription.push(this.sliderModelService.sliderCloseRqt.subscribe(x => {
      if (this.sendData) {
        //this.convertDataToPass();
        this.sliderModelService.setData<GrowerOrderItemVM[]>(this.returnItemList);
        // removed all modify related saved data
        this.globalKey.Values = [];
        localStorage.setItem(this.globalKey.Key, JSON.stringify(this.globalKey.Values));
      }

      this.resetVariables();
      this.sliderModelService.sliderCloseRqt.observers = [];

    }));

    // removed all modify related saved data
    this.globalKey.Values = [];
    localStorage.setItem(this.globalKey.Key, JSON.stringify(this.globalKey.Values));
    this.isShowPreviousBtn = false;
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setTableHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setTableHeight();
  }
  // Set Dynamic Height of the Modified product listing table
  setTableHeight() {
    const modifytableHeight = window.innerHeight - $('.prodHeaderTopSec').outerHeight() - $('.modifyProdfromTable').outerHeight() - $('.tableHead').outerHeight() - $('.tableTotalsSec').outerHeight() - 40;
    $('.modifyProdTable').css('max-height', modifytableHeight + 'px');
  }

  // Reset Variables
  resetVariables() {
    this.counter = 0;
    this.totalSum = 0;
    this.totalItems = 0;
    this.sendData = false;
    this.returnItemList = [];
    this.isShowPreviousBtn = false;
    this.isShowNextBtn = false;
  }

  // Move forward
  MoveToNextItem() {
    this.showCutOverWarning = false;
    const errors = (this.changeListDS && this.changeListDS.length > 0) ? this.changeListDS.filter(x => (x.errors && x.errors.length > 0)) : [];
    this.noError = errors && errors.length > 0 ? false : true;
    if (this.noError) {
      this.saveInLocalStorage();
      if (this.counter < this.fromProductList.length) {
        this.fromProduct = this.fromProductList[this.counter];
        if (this.fromProduct.showCutOverWarning) {
          this.showCutOverWarning = true;
        }
        this.itemId = this.fromProduct.itemID;
        this.counter = this.counter + 1;
        this.loaderService.setLoaderStatus(true);

        if (this.page == 'dealerSlider') {
          this.subscription.push(this.dealerService.getModifyItem(this.itemId.toString(), this.accountNo.toString(),
            this.cropYear.toString(), this.action, this.fromProduct.geu)
            .subscribe(x => {
              this.changeListDS = x as GrowerOrderItemVM[];
              this.changeListDS.map(x => { x.eaModifiableUnits = 0; x.eaPlannedUnits = 0;x.eaShippedUnits = 0 });
              if (this.isEAModifiableUnitsShow) {
                this.isAllChecked = false;
                // to update existing value from local storage
                if (this.changeListDS) {
                  this.changeListDS.map(x => { x.itemGroup = this.itemId.toString() });
                  var isValidEaItems = false;
                  this.changeListDS.some(x => {
                    if (x.isItemInInclusion && this.fromProduct.eaModifiableUnits > 0 && this.fromProduct.isItemInInclusion) {
                      isValidEaItems = true;
                      return true;
                    }
                  });
                  this.hasEligibleEAUnits = isValidEaItems;
                }
                if (this.isAccountRIB && this.changeListDS) {
                    this.changeListDS = this.changeListDS.filter(x => x.isRIB == true);
                }
                this.updateExistingValue(this.changeListDS);
              }
              this.totalSum = 0;
              this.loaderService.setLoaderStatus(false);
            }, (error => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);
            })));
        }
        else {
          this.subscription.push(this.growerOrderService.getGrowerProductChange(this.cropYear.toString(), this.itemId.toString(), this.action, this.accountNo.toString())
            .subscribe(x => {
              if (this.page === 'growerOrder') {
                x.forEach(x => x.geu = this.commonService.getFormatedNumber(x.geu, false));
              }
              this.changeListDS = x as GrowerOrderItemVM[];
              // to update existing value from local storage
              if (this.isAccountRIB && this.changeListDS) {
                this.changeListDS = this.changeListDS.filter(x => x.isRIB == true);
              }
              if (this.changeListDS) {
                this.updateExistingValue(this.changeListDS);
              }
              this.totalSum = 0;
              this.loaderService.setLoaderStatus(false);
            }, (error => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);
            })));
        }
      }
      if (this.counter == this.fromProductList.length) {
        this.btnTxt = '';
        this.isShowNextBtn = false;
      }
      else {
        this.btnTxt = 'Next Line Item';
        this.isShowNextBtn = true;
      }
      if (this.counter > 0) {
        this.isShowPreviousBtn = true;
      }
    }
  }

  // save In Local Storage
  saveInLocalStorage() {
    const data = this.changeListDS && this.changeListDS.length > 0 ? this.changeListDS.filter(x => x.geu > 0) : [];
    if (this.fromProduct && data.length > 0) {
      // to get key
      const key = this.getKey();
      // let totalQty = 0;
      // data.forEach(x => totalQty = (+totalQty) + (+x.geu));
      // this.fromProduct.geu = (+(this.fromProduct.netBEU) + +(this.fromProduct.softCommitUnits) + +(this.fromProduct.plannedUnits) + +(this.fromProduct.shippedUnits)) - (+totalQty);

      const value = {
        id: key,
        fromProduct: this.fromProduct,
        ProductList: data
      };
      const storageData = JSON.parse(localStorage.getItem('Modify'));
      // to remove existing record from local storage
      if (storageData) {
        const index = storageData.indexOf(x => x.id == key);
        if (index != -1) {
          storageData.splice(index, 1);
        }
      }
      // to push updated record in local storage
      this.globalKey.Values.push(value);
      localStorage.setItem(this.globalKey.Key, JSON.stringify(this.globalKey.Values));
      this.sendData = true;
    }
  }

  // GEU Value Change
  geuValueChange(action: string, productItem: any) {
    if (this.page == 'dealerSlider') {
      if (action == 'decrease') {
        this.changeListDS.forEach(item => {
          if (item.itemID == productItem.itemID) {
            const convValue = this.calculateLCM(+this.fromProduct.conv, +item.conv);
            const valueBeforeDec = item.geu;
            item.geu = Math.floor(item.geu / +convValue) * +convValue;
            if (valueBeforeDec == item.geu) {
              item.geu = ((+item.geu) > (+convValue) ? (+item.geu) - (+convValue) : 0);
            }
            if (item.geu == 0) {
              const filteredData = this.changeListDS.filter(x => x.geu > 0);
              if (filteredData.length > 0) {
                let isWarningShow = false;
                filteredData.forEach(y => {
                  if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
                    if ((y.primaryUOM === y.secondaryUOM)) {
                      isWarningShow = true;
                    }
                  }
                });
                this.showCutOverWarning = isWarningShow;
              }
              else {
                this.showCutOverWarning = false;
              }
            }
          }
        });
      }
      else {
        this.changeListDS.forEach(item => {
          if (item.itemID == productItem.itemID) {
            const convValue = this.calculateLCM(+this.fromProduct.conv, +item.conv);
            const valueBeforeInc = item.geu;
            item.geu = Math.ceil(item.geu / +convValue) * +convValue;
            if (valueBeforeInc == item.geu) {
              item.geu = (+item.geu) + (+convValue);
            }
            if (item.geu > 0) {
              if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
                if ((item.primaryUOM === item.secondaryUOM) && this.fromProduct.cutOverWarning) {
                  this.showCutOverWarning = true;
                  this.fromProduct.showCutOverWarning = true;
                }
              }
            }
            else {
              this.showCutOverWarning = false;
              this.fromProduct.showCutOverWarning = false;
            }
          }
        });
      }
    }
    else {
      if (action == 'decrease') {
        this.changeListDS.forEach(item => {
          if (item.itemID == productItem.itemID) {
            const convValue = this.calculateLCM(+this.fromProduct.conv, +item.conv);
            const valueBeforeDec = item.geu;
            item.geu = Math.floor(item.geu / +convValue) * +convValue;
            if (valueBeforeDec == item.geu) {
              item.geu = ((+item.geu) > (+convValue) ? (+item.geu) - (+convValue) : 0);
            }
            if (item.geu == 0) {
              this.showCutOverWarning = false;
              this.fromProduct.showCutOverWarning = false;
            }
          }
        });
      }
      else {
        this.changeListDS.forEach(item => {
          if (item.itemID == productItem.itemID) {
            const convValue = this.calculateLCM(+this.fromProduct.conv, +item.conv);
            const valueBeforeInc = item.geu;
            item.geu = Math.ceil(item.geu / +convValue) * +convValue;
            if (valueBeforeInc == item.geu) {
              item.geu = (+item.geu) + (+convValue);
            }
            if (item.geu > 0) {
              if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
                if ((item.primaryUOM === item.secondaryUOM) && this.fromProduct.cutOverWarning) {
                  this.showCutOverWarning = true;
                  this.fromProduct.showCutOverWarning = true;
                }
              }
            }
          }
        });
      }
    }
    this.validateQty(productItem);
    this.validateQtySum(productItem);
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.changeListDS.length });
  }

  // validate Qty Sum
  validateQtySum(element: any) {
    this.totalSum = 0;
    this.changeListDS.forEach(x => { this.totalSum = this.totalSum + (+x.geu); });
    if (this.totalSum > (+this.fromProduct.geu)) {
      this.changeListDS.forEach(item => {
        if (item.itemID == element.itemID) {
          if (item.errorFlag) {
            const errors = item.errors.filter(x => x.errorCode == errorCodes.highsum);
            if (errors && errors.length == 0) {
              item.errors.push(
                {
                  errorItemId: item.itemID.toString(),
                  errorCode: errorCodes.highsum,
                  msg: 'Units should be less/Equal to \'FromProduct\' Units'
                });
            }
          }
          else {
            item.errorFlag = true;
            item.errors = [{
              errorItemId: item.itemID.toString(),
              errorCode: errorCodes.highsum,
              msg: 'Units should be less/Equal to \'FromProduct\' Units'
            }];
          }
        }
      });
    }
    else {
      this.changeListDS.forEach(item => {
        if (item.errorFlag) {
          const errors = item.errors.filter(x => x.errorCode != errorCodes.highsum);
          item.errors = errors.length > 0 ? errors : [];
          item.errorFlag = errors.length > 0 ? true : false;
        }
      });
    }
  }

  // validate Qty
  validateQty(element: any) {
    if (element && element.geu < 0) {
      this.changeListDS.forEach(item => {
        if (item.itemID == element.itemID) {
          if (item.errorFlag) {
            const errors = item.errors.filter(x => x.errorCode == errorCodes.negative);
            if (errors && errors.length == 0) {
              item.errors.push(
                {
                  errorItemId: item.itemID.toString(),
                  errorCode: errorCodes.negative,
                  msg: 'Units should be greater than zero'
                });
            }
          }
          else {
            item.errorFlag = true;
            item.errors = [{
              errorItemId: item.itemID.toString(),
              errorCode: errorCodes.negative,
              msg: 'Units should be greater than zero'
            }];
          }
        }
      });
    }
    else if (element && +element.geu >= 0) {
      if (this.page == 'dealerSlider') {
        this.changeListDS.forEach(item => {
          if (item.itemID == element.itemID) {
            const lcmValue = this.calculateLCM(+this.fromProduct.conv, +item.conv);
            const geu = element.geu % lcmValue;
            if (geu != 0) {
              item.errorFlag = true;
              item.errors = [{
                errorItemId: item.itemID.toString(),
                errorCode: errorCodes.convFactWrong,
                msg: 'Please re-enter your Dealer Units in multiples of ' + lcmValue
              }];
            }
            else {
              item.errorFlag = false;
              item.errors = [];
            }
          }
        });
        // Bug Fix# 36120
        if (+element.geu > +element.seedAvailability) {
          this.changeListDS.forEach(item => {
            if (item.itemID == element.itemID) {
              if (item.errorFlag) {
                const errors = item.errors.filter(x => x.errorCode == errorCodes.availability);
                if (errors && errors.length == 0) {
                  item.errors.push(
                    {
                      errorItemId: item.itemID.toString(),
                      errorCode: errorCodes.availability,
                      msg: 'Units should be less/Equal to \'ToProduct\' availability'
                    });
                }
              }
              else {
                item.errorFlag = true;
                item.errors = [{
                  errorItemId: item.itemID.toString(),
                  errorCode: errorCodes.availability,
                  msg: 'Units should be less/Equal to \'ToProduct\' availability'
                }];
              }
            }
          });
        }

        if (element.geu > 0) {
          if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
            if ((element.primaryUOM === element.secondaryUOM) && this.fromProduct.cutOverWarning) {
              this.showCutOverWarning = true;
            }
          }
        }
        else {
          const filteredData = this.changeListDS.filter(x => x.geu > 0);
          if (filteredData.length > 0) {
            var isWarningShow = false;
            filteredData.forEach(y => {
              if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
                if ((y.primaryUOM === y.secondaryUOM)) {
                  isWarningShow = true;
                }
              }
            });
            this.showCutOverWarning = isWarningShow;
          }
          else {
            this.showCutOverWarning = false;
          }
        }
      }
      else {
        if (element.geu > 0) {
          if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
            if ((element.primaryUOM === element.secondaryUOM) && this.fromProduct.cutOverWarning) {
              this.showCutOverWarning = true;
            }
          }
        }
        else {
          const filteredData = this.changeListDS.filter(x => x.geu > 0);
          if (filteredData.length > 0) {
            var isWarningShow = false;
            filteredData.forEach(y => {
              if ((this.fromProduct.primaryUOM !== this.fromProduct.secondaryUOM) && this.fromProduct.conv > 1) {
                if ((y.primaryUOM === y.secondaryUOM)) {
                  isWarningShow = true;
                }
              }
            });
            this.showCutOverWarning = isWarningShow;
          }
          else {
            this.showCutOverWarning = false;
          }
        }
      }
    }
    else {
      this.changeListDS.forEach(item => {
        if (item.itemID == element.itemID) {
          if (item.errorFlag) {
            const errors = item.errors.filter(x => x.errorCode != errorCodes.negative);
            item.errors = errors.length > 0 ? errors : [];
            item.errorFlag = errors.length > 0 ? true : false;
          }
        }
      });
    }
    this.validateQtySum(element);
  }

  // convert Data To Pass
  convertDataToPass() {
    const jsonObject = JSON.parse(localStorage.getItem(this.globalKey.Key));
    if (jsonObject) {
      this.fromProductList.forEach(obj => {
        let orderItemList: GrowerOrderItemVM[] = [];

        let jsonValue: any;
        let storageData: any;
        if (this.page == 'dealerSlider') {
          storageData = jsonObject.find(x => x.id == obj.dealerOrderItemId.toString() + obj.itemNumber);
        } else {
          storageData = jsonObject.find(x => x.id == obj.growerOrderItemId.toString() + obj.itemNumber);
        }
        if (storageData) {
          jsonValue = JSON.parse(JSON.stringify(storageData)) as changeListVM;
        }
        if (jsonValue) {
          const nonzeroList = jsonValue.ProductList.filter(x => x.geu != 0);
          orderItemList.push.apply(orderItemList, nonzeroList);

          let qtySum = 0;
          jsonValue.ProductList.forEach(x => { qtySum = qtySum + (+x.geu); });

          if (qtySum != 0 && qtySum <= obj.geu) {
            if (this.page == 'dealerSlider') {
              jsonValue.fromProduct.geu = obj.netBEU - qtySum; // obj.geu to obj.netBEU
            } else {
              jsonValue.fromProduct.geu = obj.geu - qtySum; // obj.geu to obj.netBEU
            }

            jsonValue.fromProduct.isSelected = false;
            orderItemList.push(jsonValue.fromProduct);
          }

          if (qtySum > obj.geu) {
            orderItemList = [];
            alert('limit exceed' + qtySum.toString());
          }

          if (orderItemList) {
            // var id = 0;
            orderItemList.forEach(x => {
              // id = id + 1;
              x.growerGLN = obj.growerGLN;
              x.growerGMK = obj.growerGMK;
              x.growerOrderID = obj.growerOrderID;
              x.shipToAccount = obj.shipToAccount;
              x.desiredDeliveryDate = obj.desiredDeliveryDate;
              x.customerPO = obj.customerPO;
              x.sellerID = obj.sellerID;
              x.growerOrderNumber = obj.growerOrderNumber;
              x.dealerOrderNumber = obj.dealerOrderNumber;
              x.primaryUOM = obj.primaryUOM;
              x.secondaryUOM = obj.secondaryUOM;
              if (x.dealerOrderItemId == undefined) {
                x.dealerOrderItemId = 0;
              }
              if (x.growerOrderItemId == undefined) {
                x.growerOrderItemId = 0;
              }
              if (x.isSelected) {
                x.ChangeType = (this.btnAction == 'PACKAGE SIZE') ? 'PCT' : (this.btnAction == 'SEED SIZE' ? 'SCT' : 'TCT');
              }
              else {
                x.ChangeType = (this.btnAction == 'PACKAGE SIZE') ? 'PCF' : (this.btnAction == 'SEED SIZE' ? 'SCF' : 'TCF');
              }
              this.returnItemList.push(x);
            });
          }
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: 1 });
        }
        else {
          const singleObj = Object.assign({}, obj);
          singleObj.isSelected = false;
          this.returnItemList.push(obj);
        }
      });
    }
  }

  // Validate the error
  addProducts(save: boolean) {
    if (save) {
      const errors = (this.changeListDS && this.changeListDS.length > 0) ? this.changeListDS.filter(x => (x.errors && x.errors.length > 0)) : [];
      this.noError = errors && errors.length > 0 ? false : true;

      if (this.noError) {
        this.saveInLocalStorage();
        this.noError = true;
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        this.convertDataToPass();
        if (this.isEAModifiableUnitsShow) {
          this.calculateEAUnitsModifyItem();
        }
        else {
          this.sliderModelService.sliderCloseRqt.next(true);
          this.sliderModelService.close();
        }       
      }
    }
    else {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: 0 });
      this.noError = false;
      this.sendData = false;
      // removed all modify related saved data
      this.globalKey.Values = [];
      localStorage.setItem(this.globalKey.Key, JSON.stringify(this.globalKey.Values));
      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          if (result == true) {
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
            this.sliderModelService.close();
          }
        }));
      }
      else {
        this.sliderModelService.close();
      }
    }
  }

  calculateLCM(fromConv: number, toConv: number) {
    return ((+fromConv) * (+toConv)) / this.calculateGCD(fromConv, toConv);
  }

  calculateGCD(fromConv: number, toConv: number) {
    if (fromConv == 0 || toConv == 0) {
      return 0;
    }

    if (fromConv == toConv) {
      return fromConv;
    }

    if (fromConv > toConv) {
      return this.calculateGCD((+fromConv) - (+toConv), +toConv);
    }
    else {
      return this.calculateGCD(+fromConv, (+toConv) - (+fromConv));
    }
  }

  MoveToPreviousItem() {
    this.showCutOverWarning = false;
    const errors = (this.changeListDS && this.changeListDS.length > 0) ? this.changeListDS.filter(x => (x.errors && x.errors.length > 0)) : [];
    this.noError = errors && errors.length > 0 ? false : true;
    if (this.noError) {
      this.saveInLocalStorage();
      this.counter = this.counter - 1;
      if (this.counter >= 0) {
        this.fromProduct = this.fromProductList[this.counter - 1];
        if (this.fromProduct.showCutOverWarning) {
          this.showCutOverWarning = true;
        }
        this.itemId = this.fromProduct.itemID;
        // this.counter = this.counter - 1;
        this.loaderService.setLoaderStatus(true);

        if (this.page == 'dealerSlider') {
          this.subscription.push(this.dealerService.getModifyItem(this.itemId.toString(), this.accountNo.toString(),
            this.cropYear.toString(), this.action, this.fromProduct.geu)
            .subscribe(x => {
              this.changeListDS = x as GrowerOrderItemVM[];
              this.changeListDS.map(x => { x.eaModifiableUnits = 0; x.eaPlannedUnits = 0; x.eaShippedUnits = 0 });
              // to update existing value from local storage
              if (this.isEAModifiableUnitsShow) {
                this.isAllChecked = false;
                if (this.changeListDS) {
                  var isValidEaItems = false;
                  this.changeListDS.some(x => {
                    if (x.isItemInInclusion && this.fromProduct.eaModifiableUnits > 0 && this.fromProduct.isItemInInclusion) {
                      isValidEaItems = true;
                      return true;
                    }
                  });
                  this.hasEligibleEAUnits = isValidEaItems;
                }

                this.updateExistingValue(this.changeListDS);
              }
              this.totalSum = 0;
              this.loaderService.setLoaderStatus(false);
            }, (error => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);
            })));
        }
        else {
          this.subscription.push(this.growerOrderService.getGrowerProductChange(this.cropYear.toString(), this.itemId.toString(), this.action, this.accountNo.toString())
            .subscribe(x => {
              this.changeListDS = x as GrowerOrderItemVM[];
              // to update existing value from local storage
              if (this.changeListDS) {
                this.updateExistingValue(this.changeListDS);
              }
              this.totalSum = 0;
              this.loaderService.setLoaderStatus(false);
            }, (error => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);
            })));
        }
      }
      if (this.counter == this.fromProductList.length) {
        this.btnTxt = '';
        this.isShowNextBtn = false;
      }
      else {
        this.btnTxt = 'Next Line Item';
        this.isShowNextBtn = true;
      }
      if (this.counter > 1) {
        this.isShowPreviousBtn = true;
      }
      else {
        this.isShowPreviousBtn = false;
      }
      if (this.counter == 0) {
        ++this.counter;
      }
    }
  }

  // to update modify items with existing local storage data
  updateExistingValue(changedList) {
    if (changedList && changedList.length > 0) {
      let existingChangeList: GrowerOrderItemVM[];

      const data = JSON.parse(localStorage.getItem('Modify'));
      if (data) {
        // To get existing data if exist in local storage
        const dataKey = this.getKey();
        const changeList = data.find(x => x.id == dataKey);
        if (changeList) {
          existingChangeList = changeList.ProductList as GrowerOrderItemVM[];
        }
      }
      // apply existing data value
      if (existingChangeList && existingChangeList.length > 0) {
        changedList.forEach(x => {
          const item = existingChangeList.find(y => y.itemID == x.itemID);
          if (item) {
            x.geu = item.geu;
            x.isEAModifiableChecked = item.isEAModifiableChecked;
          }
        });
      }
    }
  }

  // To get unique key to get/set value in local storage
  getKey() {
    if (this.page == 'dealerSlider') {
      return this.fromProduct.dealerOrderItemId.toString() + this.fromProduct.itemNumber;
    }
    else {
      return this.fromProduct.growerOrderItemId.toString() + this.fromProduct.itemNumber;
    }
  }

  dealerPartial(element) {
    //check partial status for Treatment only in delear slider
    if (this.page == 'dealerSlider' && (this.action != 'SeedSize' && this.action != 'PackageSize')) {
      return element.isProductDeactivated === true
        && element.deactivationType != null
        && element.deactivationType.trim().toLowerCase() == 'partial';
    }
    //check high demand partial status for PackageSize if there is availability
    else if (this.page == 'dealerSlider' && this.action == 'PackageSize' && element.isHighDemand && element.seedAvailability > 0) {
      return true;
    }
    return false;
  }

  calculateEAUnitsModifyItem() {
      const data = [];
      if (this.returnItemList) {
        this.loaderService.setLoaderStatus(true);
        this.returnItemList.forEach(x => {
          data.push({
            companyCode: this.companyCode,
            cropYear: this.cropYear,
            dealerOrderNumber: x.dealerOrderNumber,
            itemId: x.itemID,
            itemNumber: x.itemNumber,
            accountId: x.shipToAccount,
            quantity: x.geu,
            uOM: x.primaryUOM,
            secondaryUOM: x.secondaryUOM,
            transactionQty: x.geu,
            lineNumber: x.lineNumber,
            updatedBy: '',
            ChangeType: x.ChangeType,
            EmailTo: '',
            isEAModifiableChecked: x.isEAModifiableChecked,
            itemGroup: x.itemGroup,
            originalDealerUnits: 0,
            eaModifiableUnits: x.eaModifiableUnits
          });
        });

        this.subscription.push(this.dealerService.calculateEAUnitsModifyItem(data)
          .subscribe(result => {
            if (result) {
              this.returnItemList.forEach(x => {
                var eaItemDetail = result.filter(item => item.itemId == x.itemID)[0];
                if (eaItemDetail) {
                  x.eaModifiableUnits = eaItemDetail.eaModifiableUnits;
                  x.eaUnits = eaItemDetail.eaUnits;
                }
              });
            }
            this.loaderService.setLoaderStatus(false);

            this.sliderModelService.sliderCloseRqt.next(true);
            this.sliderModelService.close();
          }, (error => {
            this.loaderService.setLoaderStatus(false);
          })));
      }
      else {
        this.sliderModelService.sliderCloseRqt.next(true);
        this.sliderModelService.close();
      }
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}

export class changeListVM {
  fromProduct: GrowerOrderItemVM;
  ProductList: GrowerOrderItemVM[];
}
